import { BadRequestApiError, NotFoundApiError, UnauthorizedApiError } from '~/App/utils/api'

import LoadingLayout from '../../../components/LoadingLayout'
import NotFoundPage from '../../../pages/404'
import useStore from '../../hooks/useStore'

const LoadingStore: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isLoading, isSuccess, error } = useStore()

  if (isLoading) {
    return <LoadingLayout />
  }

  if (
    error instanceof BadRequestApiError ||
    error instanceof UnauthorizedApiError ||
    error instanceof NotFoundApiError
  ) {
    return <NotFoundPage />
  }

  if (error) {
    throw error
  }

  if (!isSuccess) {
    return <NotFoundPage />
  }

  return children
}

export default LoadingStore
